import crypto from 'crypto'
import * as time from '@/libs/time'

/**
 * api.newUserPayment() で送信するデータを作成する
 *
 * @param {Object} form フォームデータ
 * @param {*} token カード情報のトークン
 * @return {Object} api.newUserPayment() で送信するデータを返す
 */
export function createCardData (form, res) {
  return {
    token: res.token,
    tokenKey: res.tokenKey,
    cardNo: maskCardNo(form.number),
    expire: getExpire(form.expire),
    holderName: form.holdername,
    hash: makeHash(form),
    securityCD: form.cvc
  }
}

/**
 * マスクしたカード番号を返す
 *
 * @param {String} number カード番号
 * @returns {String} マスクしたカード番号を返す
 */
function maskCardNo (number) {
  if (!number) {
    number = '000'
  }
  return '*************' + (number).slice(-3)
}

/**
 * 有効期限を返す
 *
 * @param {Object} expire 有効期限
 * @returns {String} 有効期限の末日を返す
 */
function getExpire (expire) {
  // 1日を示す Date オブジェクトを作成する
  const tm = time.create({ y: expire.year, m: expire.month, d: 1 })

  // 末日にする
  tm.setMonth(tm.getMonth() + 1, 0)

  // 文字列にして返す
  return time.format('Y-m-d', tm)
}

/**
 * フォーム内容を表すハッシュ値を作成する
 *
 * @param {Object} form フォームデータ
 * @return {String} フォーム内容を表すハッシュ値
 */
function makeHash (form) {
  const s = JSON.stringify(form)
  const md5 = crypto.createHash('md5')
  return md5.update(s, 'binary').digest('hex')
}
